import { PaymentMethod } from '@openeducation/pp-rn-shared-types';
import { useMemo } from 'react';

import {
  ValidatePaymentInfoParams,
  validatePaymentInfo,
  validateAdditionalPaymentInfo,
  ValidateAdditionalPaymentInfoParams,
  validateContract,
  ValidateContractParams,
  validateManualPaymentInfo,
  ValidateManualPaymentInfoParams,
} from '../helpers';

export interface IsSubmitEnabledParams {
  paymentInfo: ValidatePaymentInfoParams;
  additionalPaymentInfo?: ValidateAdditionalPaymentInfoParams;
  additionalPaymentInfo2?: ValidateAdditionalPaymentInfoParams;
  manualPaymentInfo?: ValidateManualPaymentInfoParams;
  contractInfo?: ValidateContractParams;
}

export const useIsSubmitEnabled = ({
  paymentInfo,
  additionalPaymentInfo,
  additionalPaymentInfo2,
  manualPaymentInfo,
  contractInfo,
}: IsSubmitEnabledParams) => {
  const isPaymentInfoValid = useMemo(
    () => validatePaymentInfo(paymentInfo),
    [paymentInfo]
  );

  const isAdditionalPaymentInfoValid = useMemo(
    () =>
      additionalPaymentInfo
        ? validateAdditionalPaymentInfo(additionalPaymentInfo)
        : true,
    [additionalPaymentInfo]
  );

  const isAdditionalPaymentInfo2Valid = useMemo(() => {
    if (paymentInfo.formData.paymentMethod === PaymentMethod.TWO_CREDIT_CARDS) {
      return additionalPaymentInfo2
        ? validateAdditionalPaymentInfo(additionalPaymentInfo2)
        : false;
    }
    return true;
  }, [additionalPaymentInfo2, paymentInfo.formData]);

  const isManualPaymentInfoValid = useMemo(
    () =>
      manualPaymentInfo ? validateManualPaymentInfo(manualPaymentInfo) : true,
    [manualPaymentInfo]
  );

  const isContractValid = useMemo(
    () => (contractInfo ? validateContract(contractInfo) : true),
    [contractInfo]
  );

  const isSubmitEnabled =
    isPaymentInfoValid &&
    isAdditionalPaymentInfoValid &&
    isAdditionalPaymentInfo2Valid &&
    isManualPaymentInfoValid &&
    isContractValid;

  return { isSubmitEnabled };
};
